export function formatCharacterId(characterId: number): string {
  const digits = characterId.toString().split("").reverse();
  const formatted: string[] = [];

  digits.forEach((digit, index) => {
    formatted.push(digit);
    const isNotLast = index + 1 < digits.length;
    if (isNotLast && (index + 1) % 3 === 0) {
      formatted.push("-");
    }
  });

  return formatted.reverse().join("");
}
